import { css } from "@emotion/react/macro";
import styled from "@emotion/styled/macro";
import { ReactNode } from "react";

// Hooks
import { useUI } from "../../hooks/useUI";

// Components
import { Metadata } from "./metadata";

import { Media } from "../styles/enums";

const Wrapper = styled.div<{ noScroll?: boolean }>`
  min-height: calc(100vh - 46px);
  @media ${Media.SMALL} {
    ${({ noScroll }) =>
      noScroll
        ? css`
            height: 100%;
            max-height: 100%;
            overflow: hidden;
          `
        : null}
  }
`;

export const Layout = ({
  children,
}: {
  children?: ReactNode | undefined;
}): JSX.Element => {
  const { state } = useUI();

  const { title, description, noScroll } = state;

  return (
    <Wrapper noScroll={noScroll}>
      <Metadata title={title} description={description} />
      {children}
    </Wrapper>
  );
};
